// dashboardReducer.js
import {
  FETCH_DASHBOARD,
  LOADING_DASHBOARD,
  SET_FILTRO_DASHBOARD,
  FETCH_TOTALIZADORES_TARJETA,
  FETCH_RESUMEN_ESTADOS,
  FETCH_TOP_PRODUCTOS,
  FETCH_TOP_CATEGORIAS,
  FETCH_TOP_TIPO_PUBLICACIONES
} from '../actions/types';

const initialState = {
  // isLoading: false,
  filtro: {},
  totalizadores: {
    ventas: {},
    ordenes: {},
    publicaciones: {}
  },
  core: {
    tarjetasDashboardDto: null,
    resumenEstadosOrden: null,
  },
  topProductos: null,
  topCategorias: null,
  topTipoPublicaciones: null,
  isLoading: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_DASHBOARD:
      return {
        ...state,
        totalizadores: action.payload,
      };

    case LOADING_DASHBOARD:
      return {
        ...state,
        isLoading: action.payload,
      };

    case SET_FILTRO_DASHBOARD:
      return {
        ...state,
        filtro: action.payload,
      };

    case FETCH_TOTALIZADORES_TARJETA:
      return {
        ...state,
        core: {
          ...state.core,
          tarjetasDashboardDto: action.payload,
        },
      };


    case FETCH_RESUMEN_ESTADOS: {
      return {
        ...state,
        resumenEstados: { ...action.payload },
      };
    }

    case FETCH_TOP_CATEGORIAS: {

      const list =
        action.payload?.data?.topCategorias ??   // si despachás el response de axios
        action.payload?.topCategorias ??         // si despachás el body { topCategorias: [...] }
        (Array.isArray(action.payload) ? action.payload : []); // por si ya es el array

      return {
        ...state,
        topCategorias: list,   // 👈 ahora es Array(10)
      };
    }

    case FETCH_TOP_PRODUCTOS: {
      return {
        ...state,
        topProductos: action.payload,
      };


    }

    case FETCH_TOP_TIPO_PUBLICACIONES: {
      return {
        ...state,
        topTipoPublicaciones: action.payload,
      };
    }



    default:
      return state;
  }
}
